import { BigNum, QUOTE_PRECISION_EXP } from '@velocity-exchange/sdk';
import Link from 'src/components/primitives/Link/Link';
import { AccountListItem } from './AccountListItem';
import { IFStakeItem } from './types';
import { DRIFT_TOKEN_BANK_INDEX } from 'src/environmentVariables/EnvironmentVariables';
import { POOL_NAMES_BY_POOL_ID } from 'src/constants/constants';
import Tag from 'src/components/primitives/Tag/Tag';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { useDrawersStore } from 'src/stores/useDrawersStore';

export const InsuranceFundItem = ({ item }: { item: IFStakeItem }) => {
	const isDrift = item.marketIndex === DRIFT_TOKEN_BANK_INDEX;
	const isMobile = useIsMobileScreenSize();
	const handleCloseDrawer = useDrawersStore((s) => s.handleCloseDrawer);

	const handleClick = () => {
		if (isMobile) {
			handleCloseDrawer('accounts');
		}
	};

	const href = isDrift
		? '/drift-safety-module'
		: `/vaults/insurance-fund-vaults`;

	const balance =
		item.ifData.userStake.currentStakeNotionalValue ??
		BigNum.zero(QUOTE_PRECISION_EXP);
	const poolName = POOL_NAMES_BY_POOL_ID[item.poolId];

	const nameArea = (
		<div className="flex flex-col items-start gap-x-xs typo-body-sm text-text-default">
			{isDrift ? (
				'Staked DRIFT'
			) : (
				<>
					{item.market.uiSymbols.marketDisplaySymbol} Vault
					{item.poolId > 0 && <Tag variant="neutral">{poolName}</Tag>}
				</>
			)}
		</div>
	);

	const infoArea = (
		<div className="typo-label-xs text-text-default">
			${balance.toMillified()}
		</div>
	);

	return (
		<Link href={href} className="w-full" rightIcon="none">
			<AccountListItem
				nameArea={nameArea}
				infoArea={infoArea}
				onClick={handleClick}
			/>
		</Link>
	);
};
